'use client';
import { Space, Stack } from '@mantine/core';
import BookingAlert from './components/booking-alert';
import BookingPaths from './components/paths';
import BikeSpecialRequests from '@/features/booking/components/bike-special-request/special-request';
import BookingConfirmOrder from '@/features/booking/components/booking-confirm-order';
import { useTruckService } from '@/features/booking/components/services/use-truck-service';
import TruckBulkyPackageDetail from '@/features/booking/components/truck/truck-package-detail/truck-bulky-package-detail';
import TruckPackageDetail from '@/features/booking/components/truck/truck-package-detail/truck-package-detail';
import TruckService from '@/features/booking/components/truck/truck-service/truck-service';

export default function TruckContainer() {
  // const { truckSelectedGroup } = useBookingStore((state) => state);
  const { isHiddenTruck, isBulkyNewFlow } = useTruckService();
  return (
    <>
      <Stack gap="md" px="md" w="100%">
        <BookingAlert />

        <BookingPaths />
        {!isHiddenTruck && <TruckService />}

        {!isHiddenTruck &&
          (isBulkyNewFlow ? (
            <TruckBulkyPackageDetail />
          ) : (
            <TruckPackageDetail />
          ))}
        {/* {!isHiddenTruck && <TruckPackageDetail />} */}
        {!isHiddenTruck && <BikeSpecialRequests />}
      </Stack>

      <Space className="h-48 md:h-72" />

      {!isHiddenTruck && <BookingConfirmOrder />}
    </>
  );
}
